import React, { useEffect } from 'react'
import { HiOutlineDocumentDuplicate } from 'react-icons/hi2'
import { MdOutlineLibraryBooks } from 'react-icons/md'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import PageTitle from '../../../components/partials/PageTitle'
import { resetCustomerOverviewData } from '../../../redux/slice/report/reportSlice'


const customerReports = [
    {name: 'Trial Balance',icon: <HiOutlineDocumentDuplicate size={26}/>, link: '/admin/reports/financial-report/trial-balance', permission: 'customer policy information report'},
    {name: 'Balance Sheet',icon: <MdOutlineLibraryBooks size={26} />, link: '/admin/reports/policy-report/policy-expiry', permission: 'customer policy expiry-renewal date report'},
]
const FinancialReport = () => {

    const { user_permissions } = useSelector((state) => state?.auth?.user);

    const dispatch = useDispatch()
    // const navigate = useNavigate();

    const breadcrumb = {
        from: {
          title: "Reports",
          link: "/admin/reports",
        },
        current: {
          title: "Financial Report",
          link: null,
        },
      };

    useEffect(() => {
        dispatch(resetCustomerOverviewData())
      }, [dispatch])
  
    const filteredReports = customerReports.filter((item) => {
    return user_permissions?.some((permission) => permission.name === item.permission);
    });
  return (
    <>
        {/* page title */}
        <PageTitle title='Financial Report' breadcrumb={breadcrumb} />
        {/* end page title */}
        <div className='row gap-4 p-1 mt-2' style={{ margin: "auto 1px" }}>
            {filteredReports.map((item, i) => (
                <Link to={item?.link} className='col-3 card p-3 hover-primary' key={i}>
                    <div className=' d-flex gap-2 flex-column  align-items-center'>
                        <div>
                            <span className='icon-primary'>{item?.icon}</span>
                        </div>
                        <div>
                            <p>{item?.name}</p>
                        </div>
                    </div>
                </Link>
            ))}
        </div>
    </>
  )
}

export default FinancialReport